import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function AboutPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#EEF4F7]">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#81D8D0]/95 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-24 sm:h-28">
            <Link to="/" className="flex items-center flex-shrink-0">
              <img
                src="https://static.readdy.ai/image/8518bd20f704ac7d2f3f65f4644eeb9a/37cbdfbab98dc394d9ee285d8ad1648c.svg"
                alt="PawBridge"
                className="w-40 h-40 sm:w-48 sm:h-48 object-contain brightness-0"
              />
            </Link>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center gap-10">
              <Link to="/about" className="relative text-base font-semibold text-white whitespace-nowrap group">
                PawBridgeについて
                <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-white rounded-full"></span>
              </Link>
              <Link to="/sitters" className="relative text-base font-medium text-white hover:text-white transition-colors whitespace-nowrap group">
                シッターを探す
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link to="/sitter-registration" className="relative text-base font-medium text-white hover:text-white transition-colors whitespace-nowrap group">
                シッター登録
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link
                to="/login"
                className="px-6 py-2.5 bg-white text-[#81D8D0] text-base font-bold rounded-full hover:bg-[#1B2A4A] hover:text-white transition-all shadow-md hover:shadow-lg whitespace-nowrap"
              >
                ログイン
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer">
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden mt-4 pb-4 space-y-3">
              <Link to="/about" onClick={() => setMobileMenuOpen(false)} className="block text-sm font-semibold text-white py-2">PawBridgeについて</Link>
              <Link to="/sitters" onClick={() => setMobileMenuOpen(false)} className="block text-sm text-white hover:text-white/80 transition-colors py-2">シッターを探す</Link>
              <Link to="/sitter-registration" onClick={() => setMobileMenuOpen(false)} className="block text-sm text-white hover:text-white/80 transition-colors py-2">シッター登録</Link>
              <Link to="/login" onClick={() => setMobileMenuOpen(false)} className="block text-sm text-white hover:text-white/80 transition-colors py-2">ログイン</Link>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-28 sm:pt-32 pb-12 md:pb-20 px-4 md:px-6 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-[#D4E8EC]/30 to-transparent"></div>
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <h1 className="text-3xl md:text-5xl font-bold text-[#1B2A4A] mb-4 md:mb-6 leading-tight">
            PawBridgeについて
          </h1>
          <p className="text-base md:text-xl text-[#1B2A4A]/60 leading-relaxed">
            海外で暮らす日本人同士が、ペットを通じて助け合える場所
          </p>
        </div>
      </section>

      <article className="max-w-4xl mx-auto px-4 md:px-6 pb-16 md:pb-24 space-y-12 md:space-y-20">

        {/* ① 共感セクション：だから、PawBridgeをつくりました */}
        <section>
          <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-10 lg:p-14 border border-[#D4E8EC]">
            <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-[#81D8D0]/10 rounded-full mb-6 md:mb-8 mx-auto">
              <i className="ri-heart-line text-3xl md:text-4xl text-[#81D8D0]"></i>
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1B2A4A] mb-6 md:mb-8 text-center">
              だから、PawBridgeをつくりました
            </h2>
            <div className="prose prose-lg max-w-none text-[#1B2A4A]/80 leading-relaxed space-y-4 md:space-y-6 text-sm md:text-base">
              <p>
                私は今、海外で犬と暮らしています。<br />
                でも海外生活では、家族や頼れる人が近くにいないことがほとんどです。
              </p>
              <p className="font-medium text-[#1B2A4A] text-base md:text-lg">
                もし、自分が突然体調を崩したら。<br />
                もし、ケガをして散歩に行けなくなったら。<br />
                もし、急な帰国やトラブルで、どうしても預けなければならなくなったら。
              </p>
              <p>
                そのとき、安心して任せられる人はいますか？
              </p>
              <p>
                言葉が通じること。<br />
                感覚が通じること。<br />
                「大切にしてほしい」がちゃんと伝わること。
              </p>
              <p>
                それは、想像以上に大事なことでした。
              </p>
              <p>
                海外でも、<br />
                安心して愛犬を任せられる場所をつくりたい。
              </p>
              <p>
                それが、PawBridgeです。
              </p>
            </div>
          </div>
        </section>

        {/* ② 不安の言語化セクション：ペットは家族、だからこそ */}
        <section>
          <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-10 lg:p-14 border border-[#D4E8EC]">
            <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-[#81D8D0]/10 rounded-full mb-6 md:mb-8 mx-auto">
              <i className="ri-question-line text-3xl md:text-4xl text-[#81D8D0]"></i>
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1B2A4A] mb-6 md:mb-8 text-center">
              ペットは家族、だからこそ
            </h2>
            <div className="prose prose-lg max-w-none text-[#1B2A4A]/80 leading-relaxed space-y-4 md:space-y-6 text-sm md:text-base">
              <p>
                ペットはただの動物ではなく、<br />
                <strong className="text-[#81D8D0]">家族であり、子どものように大切な存在</strong>です。
              </p>
              <p>
                しかし、海外でペットシッターを探すと<br />
                価値観の違い、言葉の壁、文化の違いなどから<br />
                「本当に安心して任せられるのだろうか」と感じることも少なくありません。
              </p>
              <div className="bg-[#EEF4F7] rounded-xl md:rounded-2xl p-4 md:p-8 my-6 md:my-8 border-l-4 border-[#81D8D0]">
                <ul className="space-y-3 md:space-y-4 text-[#1B2A4A]/80">
                  <li className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 mr-2 md:mr-3">
                      <i className="ri-close-circle-line text-[#81D8D0] text-lg md:text-xl"></i>
                    </div>
                    <span className="text-sm md:text-base">言葉の壁で細かい要望が伝わらない</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 mr-2 md:mr-3">
                      <i className="ri-close-circle-line text-[#81D8D0] text-lg md:text-xl"></i>
                    </div>
                    <span className="text-sm md:text-base">ペットへの接し方の文化的な違い</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 mr-2 md:mr-3">
                      <i className="ri-close-circle-line text-[#81D8D0] text-lg md:text-xl"></i>
                    </div>
                    <span className="text-sm md:text-base">緊急時のコミュニケーションへの不安</span>
                  </li>
                </ul>
              </div>
              <p>
                私は、この不安を少しでも解消したいと思いました。
              </p>
            </div>
          </div>
        </section>

        {/* ②-補足 いざという時のために、今から慣れておく */}
        <section>
          <div className="bg-[#EEF4F7] rounded-2xl md:rounded-3xl p-6 md:p-10 lg:p-14 border border-[#D4E8EC]">
            <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-[#81D8D0]/10 rounded-full mb-6 md:mb-8 mx-auto">
              <i className="ri-time-line text-3xl md:text-4xl text-[#81D8D0]"></i>
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1B2A4A] mb-6 md:mb-8 text-center">
              いざという時のために、今から慣れておく
            </h2>
            <div className="prose prose-lg max-w-none text-[#1B2A4A]/80 leading-relaxed space-y-4 md:space-y-6 text-sm md:text-base">
              <p>
                ペットも「預けられること」に慣れておくことが大切です。
              </p>
              <p>
                突然知らない人に預けられるのは、<br />
                ペットにとって大きなストレスになります。
              </p>
              <p>
                普段から少しずつ慣れておくことで、<br />
                安心して過ごせる環境をつくることができます。
              </p>
            </div>

            {/* 3ステップ */}
            <div className="mt-8 md:mt-10 space-y-4 md:space-y-5">
              <p className="text-sm md:text-base font-semibold text-[#1B2A4A] mb-2">慣れておくための3ステップ</p>

              <div className="flex items-start gap-4 md:gap-5 bg-white rounded-xl md:rounded-2xl p-5 md:p-6 border border-[#D4E8EC]">
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-[#81D8D0] text-white font-bold text-base">
                  1
                </div>
                <div>
                  <p className="text-sm md:text-base font-semibold text-[#1B2A4A] mb-1">まずは「顔合わせ」から</p>
                  <p className="text-xs md:text-sm text-[#1B2A4A]/60">シッターとペットが初めて会う機会を設けましょう。お互いの雰囲気を確認するだけでも、ペットの安心感が大きく変わります。</p>
                </div>
              </div>

              <div className="flex items-start gap-4 md:gap-5 bg-white rounded-xl md:rounded-2xl p-5 md:p-6 border border-[#D4E8EC]">
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-[#81D8D0] text-white font-bold text-base">
                  2
                </div>
                <div>
                  <p className="text-sm md:text-base font-semibold text-[#1B2A4A] mb-1">1〜2時間の短いお預けを試す</p>
                  <p className="text-xs md:text-sm text-[#1B2A4A]/60">最初から長時間は必要ありません。短い時間から始めることで、ペットが「預けられても大丈夫」と学んでいきます。</p>
                </div>
              </div>

              <div className="flex items-start gap-4 md:gap-5 bg-white rounded-xl md:rounded-2xl p-5 md:p-6 border border-[#D4E8EC]">
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-[#81D8D0] text-white font-bold text-base">
                  3
                </div>
                <div>
                  <p className="text-sm md:text-base font-semibold text-[#1B2A4A] mb-1">月1回ペースで定期的に続ける</p>
                  <p className="text-xs md:text-sm text-[#1B2A4A]/60">継続することで、ペットにとってシッターが「知っている人」になります。いざという時も、慣れた環境として安心して過ごせます。</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ③ 新規セクション：日本人だからこそ、安心して任せられる */}
        <section>
          <div className="bg-gradient-to-br from-[#81D8D0]/10 to-[#D4E8EC]/30 rounded-2xl md:rounded-3xl p-6 md:p-10 lg:p-14 border border-[#81D8D0]/20">
            <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-[#81D8D0] rounded-full mb-6 md:mb-8 mx-auto">
              <i className="ri-shield-check-line text-3xl md:text-4xl text-white"></i>
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1B2A4A] mb-4 md:mb-6 text-center">
              日本人だからこそ、安心して任せられる
            </h2>
            <p className="text-sm md:text-base text-[#1B2A4A]/70 text-center mb-8 md:mb-10 leading-relaxed">
              PawBridgeでは、日本人同士だからこそ伝わる安心感を大切にしています。
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-8 md:mb-10">
              <div className="bg-white rounded-xl md:rounded-2xl p-5 md:p-7 text-center border border-[#D4E8EC]">
                <div className="w-12 h-12 flex items-center justify-center bg-[#81D8D0]/10 rounded-full mx-auto mb-4">
                  <i className="ri-translate-2 text-2xl text-[#81D8D0]"></i>
                </div>
                <p className="text-sm md:text-base font-semibold text-[#1B2A4A]">言葉が通じる</p>
              </div>
              <div className="bg-white rounded-xl md:rounded-2xl p-5 md:p-7 text-center border border-[#D4E8EC]">
                <div className="w-12 h-12 flex items-center justify-center bg-[#81D8D0]/10 rounded-full mx-auto mb-4">
                  <i className="ri-chat-check-line text-2xl text-[#81D8D0]"></i>
                </div>
                <p className="text-sm md:text-base font-semibold text-[#1B2A4A]">細かい要望が伝わる</p>
              </div>
              <div className="bg-white rounded-xl md:rounded-2xl p-5 md:p-7 text-center border border-[#D4E8EC]">
                <div className="w-12 h-12 flex items-center justify-center bg-[#81D8D0]/10 rounded-full mx-auto mb-4">
                  <i className="ri-heart-2-line text-2xl text-[#81D8D0]"></i>
                </div>
                <p className="text-sm md:text-base font-semibold text-[#1B2A4A]">ペットへの価値観が近い</p>
              </div>
            </div>
            <p className="text-center text-base md:text-lg font-medium text-[#1B2A4A]">
              だからこそ、安心して任せられる関係が生まれます。
            </p>
          </div>
        </section>

        {/* ④ 信頼セクション：安心して任せられる理由 */}
        <section>
          <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-10 lg:p-14 border border-[#D4E8EC]">
            <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-[#81D8D0]/10 rounded-full mb-6 md:mb-8 mx-auto">
              <i className="ri-award-line text-3xl md:text-4xl text-[#81D8D0]"></i>
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1B2A4A] mb-8 md:mb-10 text-center">
              安心して任せられる理由
            </h2>
            <div className="space-y-4 md:space-y-5">
              <div className="flex items-start gap-4 md:gap-5 p-5 md:p-6 bg-[#EEF4F7] rounded-xl md:rounded-2xl">
                <div className="w-10 h-10 flex items-center justify-center bg-[#81D8D0] rounded-full flex-shrink-0 mt-0.5">
                  <i className="ri-user-follow-line text-lg text-white"></i>
                </div>
                <div>
                  <p className="text-sm md:text-base font-semibold text-[#1B2A4A] mb-1">本人確認済みのシッターのみ掲載</p>
                  <p className="text-xs md:text-sm text-[#1B2A4A]/60">審査を通過した信頼できるシッターだけがプロフィールを公開できます。</p>
                </div>
              </div>
              <div className="flex items-start gap-4 md:gap-5 p-5 md:p-6 bg-[#EEF4F7] rounded-xl md:rounded-2xl">
                <div className="w-10 h-10 flex items-center justify-center bg-[#81D8D0] rounded-full flex-shrink-0 mt-0.5">
                  <i className="ri-star-line text-lg text-white"></i>
                </div>
                <div>
                  <p className="text-sm md:text-base font-semibold text-[#1B2A4A] mb-1">レビュー・評価システム</p>
                  <p className="text-xs md:text-sm text-[#1B2A4A]/60">実際に利用したオーナーの口コミをもとに、シッターを選べます。</p>
                </div>
              </div>
              <div className="flex items-start gap-4 md:gap-5 p-5 md:p-6 bg-[#EEF4F7] rounded-xl md:rounded-2xl">
                <div className="w-10 h-10 flex items-center justify-center bg-[#81D8D0] rounded-full flex-shrink-0 mt-0.5">
                  <i className="ri-message-3-line text-lg text-white"></i>
                </div>
                <div>
                  <p className="text-sm md:text-base font-semibold text-[#1B2A4A] mb-1">事前にメッセージで相談可能</p>
                  <p className="text-xs md:text-sm text-[#1B2A4A]/60">予約前にシッターと直接やりとりして、不安をすべて解消してから依頼できます。</p>
                </div>
              </div>
              <div className="flex items-start gap-4 md:gap-5 p-5 md:p-6 bg-[#EEF4F7] rounded-xl md:rounded-2xl">
                <div className="w-10 h-10 flex items-center justify-center bg-[#81D8D0] rounded-full flex-shrink-0 mt-0.5">
                  <i className="ri-first-aid-kit-line text-lg text-white"></i>
                </div>
                <div>
                  <p className="text-sm md:text-base font-semibold text-[#1B2A4A] mb-1">万が一のトラブルにも対応</p>
                  <p className="text-xs md:text-sm text-[#1B2A4A]/60">PawBridgeでは、万が一の事故やケガに備えたサポート体制を整えています。通院費など、一定範囲でのサポートを行います。</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ⑤ PawBridgeの誕生（サービス説明） */}
        <section>
          <div className="bg-gradient-to-br from-[#81D8D0]/10 to-[#D4E8EC]/20 rounded-2xl md:rounded-3xl p-6 md:p-10 lg:p-14 border border-[#81D8D0]/20">
            <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-[#81D8D0] rounded-full mb-6 md:mb-8 mx-auto">
              <i className="ri-lightbulb-line text-3xl md:text-4xl text-white"></i>
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1B2A4A] mb-6 md:mb-8 text-center">
              PawBridgeの誕生
            </h2>
            <div className="prose prose-lg max-w-none text-[#1B2A4A]/80 leading-relaxed space-y-4 md:space-y-6 text-sm md:text-base">
              <p>
                海外で暮らす日本人同士なら、<br />
                同じ価値観や文化を共有し、<br />
                お互いの状況を理解し合えるはずです。
              </p>
              <p className="text-lg md:text-xl font-medium text-[#81D8D0] text-center my-6 md:my-10">
                そこで生まれたのが <strong>PawBridge</strong> です。
              </p>
              <div className="bg-white rounded-xl md:rounded-2xl p-6 md:p-10 my-6 md:my-10">
                <p className="text-center text-base md:text-lg text-[#1B2A4A] leading-relaxed">
                  PawBridgeは、<br />
                  海外に住む日本人同士がペットを通じて助け合える<br />
                  <strong className="text-[#81D8D0]">ペットシッターマッチングサービス</strong>です。
                </p>
              </div>
              <p className="text-center text-base md:text-lg">
                ペットを預ける人と、ペットを預かる人。<br />
                その間に<strong className="text-[#81D8D0]">「安心」と「信頼の橋」</strong>をかける。
              </p>
              <p className="text-center text-lg md:text-xl font-bold text-[#1B2A4A] mt-6 md:mt-8">
                それが <span className="text-[#81D8D0]">PawBridge</span> の役割です。
              </p>
            </div>
          </div>
        </section>

        {/* ⑥ ビジョン（最後に配置） */}
        <section>
          <div className="bg-[#1B2A4A] rounded-2xl md:rounded-3xl p-6 md:p-10 lg:p-14 text-white">
            <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-white/20 rounded-full mb-6 md:mb-8 mx-auto">
              <i className="ri-compass-3-line text-3xl md:text-4xl text-white"></i>
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-6 md:mb-8 text-center">
              ビジョン
            </h2>
            <div className="prose prose-lg max-w-none leading-relaxed space-y-4 md:space-y-6 text-white/90 text-sm md:text-base">
              <p className="text-center text-base md:text-lg">
                PawBridgeは、<br />
                海外で暮らす日本人コミュニティから始まり、
              </p>
              <p className="text-center text-lg md:text-xl font-medium my-6 md:my-10">
                世界中のペットオーナーが<br />
                安心してペットを預けられる社会を作ることを目指します。
              </p>
              <div className="bg-white/10 rounded-xl md:rounded-2xl p-4 md:p-8 my-6 md:my-10 backdrop-blur-sm">
                <p className="text-center text-base md:text-lg">
                  ペットは家族。<br />
                  だからこそ、信頼できる人に預けたい。
                </p>
              </div>
              <p className="text-center text-lg md:text-xl font-bold mt-6 md:mt-10">
                その想いをつなぐ橋になること。<br />
                それが PawBridgeです。
              </p>
            </div>
          </div>
        </section>

        {/* ⑦ CTAセクション：今すぐ、安心して任せられるシッターを探す */}
        <section>
          <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-10 lg:p-14 border border-[#D4E8EC]">
            <div className="text-center">
              <h3 className="text-2xl md:text-3xl font-bold text-[#1B2A4A] mb-4 md:mb-6">
                今すぐ、安心して任せられるシッターを探す
              </h3>
              <p className="text-sm md:text-base text-[#1B2A4A]/60 mb-8 md:mb-10 leading-relaxed">
                日本人シッターがあなたのそばで、大切なペットを心を込めてお世話します。
              </p>
              <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
                <Link
                  to="/sitters"
                  className="inline-flex items-center justify-center px-8 md:px-10 py-3.5 md:py-4 bg-[#81D8D0] text-white rounded-full font-bold hover:bg-[#1B2A4A] transition-all whitespace-nowrap text-sm md:text-base"
                >
                  <div className="w-5 h-5 flex items-center justify-center mr-2">
                    <i className="ri-search-line text-lg"></i>
                  </div>
                  近くのシッターを探す
                </Link>
                <Link
                  to="/sitter-registration"
                  className="inline-flex items-center justify-center px-8 md:px-10 py-3.5 md:py-4 bg-white text-[#1B2A4A] border-2 border-[#1B2A4A] rounded-full font-semibold hover:bg-[#1B2A4A] hover:text-white transition-all whitespace-nowrap text-sm md:text-base"
                >
                  <div className="w-5 h-5 flex items-center justify-center mr-2">
                    <i className="ri-user-add-line text-lg"></i>
                  </div>
                  シッターとして登録
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* ⑧ お問い合わせCTA */}
        <section>
          <div className="bg-[#EEF4F7] rounded-2xl md:rounded-3xl p-6 md:p-8 border border-[#D4E8EC] flex flex-col sm:flex-row items-center justify-between gap-5">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#81D8D0]/20 flex-shrink-0">
                <i className="ri-mail-send-line text-2xl text-[#81D8D0]"></i>
              </div>
              <div>
                <p className="text-base font-bold text-[#1B2A4A]">ご質問・ご要望はお気軽に</p>
                <p className="text-xs md:text-sm text-[#1B2A4A]/60 mt-0.5">サービスや料金、シッター登録など何でもお聞きください。通常2〜3営業日以内にご返信します。</p>
              </div>
            </div>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-7 py-3 bg-[#1B2A4A] text-white text-sm font-bold rounded-full hover:bg-[#81D8D0] transition-all whitespace-nowrap flex-shrink-0"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-line text-base"></i>
              </div>
              お問い合わせはこちら
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-base"></i>
              </div>
            </Link>
          </div>
        </section>

      </article>

      {/* Footer */}
      <footer className="bg-[#81D8D0] text-white pt-12 md:pt-20 pb-8 md:pb-10">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 md:gap-12 mb-8 md:mb-12">
            <div>
              <img
                src="https://static.readdy.ai/image/8518bd20f704ac7d2f3f65f4644eeb9a/37cbdfbab98dc394d9ee285d8ad1648c.svg"
                alt="PawBridge"
                className="h-28 md:h-36 mb-4 md:mb-5 brightness-0"
              />
              <p className="text-xs md:text-sm text-white/80 leading-relaxed">
                海外在住日本人のための<br />ペットシッターコミュニティ
              </p>
            </div>
            <div>
              <h4 className="text-xs md:text-sm font-semibold uppercase mb-4 md:mb-6">サービス</h4>
              <ul className="space-y-3 md:space-y-4">
                <li><Link to="/sitters" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">シッター検索</Link></li>
                <li><Link to="/sitter-registration" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">シッター登録</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs md:text-sm font-semibold uppercase mb-4 md:mb-6">会社情報</h4>
              <ul className="space-y-3 md:space-y-4">
                <li><Link to="/about" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridgeについて</Link></li>
                <li><Link to="/contact" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">お問い合わせ</Link></li>
                <li><Link to="/terms" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridge 利用規約</Link></li>
                <li><Link to="/sitter-terms" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridge シッター利用規約</Link></li>
                <li><Link to="/guarantee" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridge 安心保証規約</Link></li>
                <li><Link to="/privacy" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">プライバシーポリシー</Link></li>
              </ul>
            </div>
          </div>
          <div className="pt-6 md:pt-8 border-t border-white/30 text-center">
            <p className="text-xs text-white/70">© 2025 PawBridge. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
